/**
 * Highlight de matches da query num texto.
 *
 * Retorna um array de ``string | { match: string }`` em vez de HTML --
 * o consumidor renderiza ``<mark>`` no React (sem ``dangerouslySet``).
 */

import type { ReactNode } from "react";
import { createElement, Fragment } from "react";

function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function highlightQuery(text: string, query: string): ReactNode {
  const trimmed = query.trim();
  if (!trimmed) return text;
  const pattern = new RegExp(`(${escapeRegex(trimmed)})`, "gi");
  const parts = text.split(pattern);
  return createElement(
    Fragment,
    null,
    ...parts.map((part, i) =>
      pattern.test(part)
        ? createElement(
            "mark",
            { key: i, className: "rounded bg-yellow-200 px-0.5" },
            part,
          )
        : part,
    ),
  );
}
